module.exports = __webpack_public_path__ + "img/receipt_white.d6c52310.png";